// extracted by mini-css-extract-plugin
export default {"testResultsContainer":"TestResultsWhiteBoxContent_testResultsContainer__46HbH"};